export const RoutePath = {
  LOGIN: "/login",
  LOGIN_EXT: "/login-ext",
  LOGIN_GEAF: "/Login-geaf",
  LOGOUT: "/logout",
  HOME: "/home",
  CHANGE_COMPANY: "/change-company",
  CHANGE_USER_PRODUCT: "/change-user-product",
  CREATE_USER: "/create-user",
  CREATE_FORM: "/create-form",
  FILTERS: "/filters",
  RESOURCES_VIEWS: "/resources-views",
  PROFILE: "/profile",
  CHANGE_PASSWORD: "/change-password",
  COMPANIES: "/companies",
  DOCUMENTS_SENT: "/documents-sent",
  ABOUT: "/about",
  EDI: "/edi",
  TODO: "/todo",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",

  DOCUMENTS_PORTAL: "/documents-portal",

  IMPERSONATE: "/impersonate",
};

export const BASENAME = "/webapp2";
